var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFaceEvent(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 36,
    viewBox: "0 0 37 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.333008,
    width: 36,
    height: 36,
    rx: 8,
    fill: "none"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.4474 19.8856C17.4888 20.927 19.1772 20.927 20.2186 19.8856M20.333 16.6667H20.3263M16.333 16.6667H16.3263M12.333 18C12.333 21.3137 15.0193 24 18.333 24C21.6467 24 24.333 21.3137 24.333 18C24.333 14.6863 21.6467 12 18.333 12C15.0193 12 12.333 14.6863 12.333 18Z",
    stroke: "#fff",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFaceEvent);
export default __webpack_public_path__ + "static/media/FaceEvent.ed318b1eaec1c1044ff441f03fb7a088.svg";
export { ForwardRef as ReactComponent };